module.exports = __webpack_public_path__ + "static/media/Void Spirit.6bcf9a94.png";